module.exports = __webpack_public_path__ + "static/media/ListEditPreview.24a437e4.png";